import React from "react";

export default function PrivacyPolicy() {
    const styles = {
        container: {
            maxWidth: "900px",
            margin: "84px auto",
            padding: "30px",
            fontFamily: "Arial, sans-serif",
            lineHeight: "1.7",
            color: "#333",
            backgroundColor: "#ffffff"
        },
        h1: {
            fontSize: "32px",
            marginBottom: "20px",
            textAlign: "center",
            color: "#1a237e"
        },
        h2: {
            fontSize: "22px",
            marginTop: "30px",
            marginBottom: "10px",
            color: "#283593"
        },
        h3: {
            fontSize: "18px",
            marginTop: "20px",
            color: "#3949ab"
        },
        p: {
            fontSize: "15px",
            marginBottom: "10px"
        }
    };

    return (
        <div>
        <section className="ptb-50 ptb-xs-30 gray-bg">
            <div className="container">
                <div className="row testimonial">   <div style={styles.container}>
                    <h1 style={styles.h1}>Privacy Policy</h1>

                    <h2 style={styles.h2}>Introduction</h2>
                    <p style={styles.p}>
                        This Privacy Policy outlines the approach of Warner Supreme Technocom
                        Private Limited (“Company,” “we,” “us,” or “our”) to data protection and
                        privacy, fulfilling its obligations under applicable laws and
                        regulations.
                    </p>
                    <p style={styles.p}>
                        This Policy applies to your Personal Information processed by us,
                        whether in physical or electronic mode. By visiting the Coreprix Pro
                        mobile application (“App”) or providing your information, you agree to
                        be bound by this Privacy Policy and applicable laws.
                    </p>

                    <h2 style={styles.h2}>1. How We Collect Your Information</h2>

                    <h3 style={styles.h3}>Registered Account Information</h3>
                    <p style={styles.p}>
                        When you register for an account, we collect your account name, contact
                        information (email, phone number), username, and login credentials.
                    </p>

                    <h3 style={styles.h3}>Location Information</h3>
                    <p style={styles.p}>
                        When you enable location services, we collect your location information
                        to configure the network with your smart device. You can disable this
                        via device settings.
                    </p>

                    <h3 style={styles.h3}>Camera Access</h3>
                    <p style={styles.p}>
                        Camera access is used only to scan QR codes for adding devices. Light
                        sensor data may be used to manage flash requirements.
                    </p>

                    <h3 style={styles.h3}>Photo and Video Uploads</h3>
                    <p style={styles.p}>
                        If album permissions are enabled, you may upload photos or videos to
                        report device issues. These are used solely for troubleshooting.
                    </p>

                    <h3 style={styles.h3}>Microphone-Based Services</h3>
                    <p style={styles.p}>
                        Voice information is collected only when you actively use microphone
                        features such as voice commands or video recording.
                    </p>

                    <h3 style={styles.h3}>Notification Permissions</h3>
                    <p style={styles.p}>
                        Notification permissions allow us to send service updates and alerts.
                        You can manage these permissions in your device settings.
                    </p>

                    <h2 style={styles.h2}>Smart Device Information</h2>

                    <p style={styles.p}>
                        We collect basic device information such as device name, ID, online
                        status, firmware version, and activation time.
                    </p>
                    <p style={styles.p}>
                        Depending on connection type, we may collect MAC address, Wi-Fi SSID,
                        and BSSID information.
                    </p>

                    <h2 style={styles.h2}>2. Information We Collect</h2>
                    <p style={styles.p}>
                        We use collected information to verify identity, maintain accounts,
                        process transactions, and communicate with users.
                    </p>

                    <p style={styles.p}>
                        Information may include demographic details, contact details, financial
                        data, government identifiers, and criminal records where legally
                        required.
                    </p>

                    <h2 style={styles.h2}>3. Collection Channels</h2>
                    <p style={styles.p}>
                        Information is collected directly through app usage, communications,
                        surveys, promotions, public forums, third-party sources, and automated
                        technologies.
                    </p>

                    <h2 style={styles.h2}>4. Children's Privacy</h2>
                    <p style={styles.p}>
                        Our App is intended for adults only. We do not knowingly collect data
                        from minors.
                    </p>

                    <h2 style={styles.h2}>5. How We Use Your Information</h2>
                    <p style={styles.p}>
                        We use your information to provide services, improve performance,
                        communicate with users, conduct research, perform marketing, and meet
                        legal obligations.
                    </p>

                    <h2 style={styles.h2}>6. Information Sharing</h2>
                    <p style={styles.p}>
                        We may share information with trusted third parties, affiliates, and
                        service providers under strict confidentiality obligations.
                    </p>

                    <h2 style={styles.h2}>7. Statutory and Regulatory Compliance</h2>
                    <p style={styles.p}>
                        Information may be disclosed to law enforcement, courts, regulators,
                        and statutory bodies when required by law.
                    </p>

                    <h2 style={styles.h2}>8. Data Security Measures</h2>
                    <p style={styles.p}>
                        We implement security measures including encrypted transactions,
                        firewalls, and periodic reviews of security practices.
                    </p>

                    <h2 style={styles.h2}>9. Data Retention</h2>
                    <p style={styles.p}>
                        Data is retained only as long as necessary to fulfill policy purposes
                        or legal obligations.
                    </p>

                    <h2 style={styles.h2}>10. International Transfers</h2>
                    <p style={styles.p}>
                        Your information may be transferred internationally with safeguards
                        to ensure legal compliance.
                    </p>

                    <h2 style={styles.h2}>11. Your Rights</h2>
                    <p style={styles.p}>
                        You have rights to access, correct, erase, restrict, object to
                        processing, and transfer your data, subject to legal conditions.
                    </p>

                    <h2 style={styles.h2}>12. Changes to This Policy</h2>
                    <p style={styles.p}>
                        We may update this Privacy Policy periodically. Changes will be posted
                        on the App.
                    </p>

                    <h2 style={styles.h2}>13. Contact Information</h2>
                    <p style={styles.p}>
                        Supreme Technocom Private Limited
                    </p>
                    <p style={styles.p}>
                        2nd Floor, 159, Opp. Rathore Nagar, Vaishali Nagar, Jaipur, Rajasthan – 302021
                    </p>
                    <p style={styles.p}>
                        Email: info@coreprix.com | Phone: 8875333777
                    </p>
                </div>
                </div>
            </div>
        </section>
         </div>

    );
}